/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость (Images-Service) API
 * Инструменты разработчика: [ [Документация API. Swagger](/docs/) ] [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse200,
    InlineResponse200FromJSON,
    InlineResponse200ToJSON,
} from '../models';

export interface AttachmentsV1IdGetRequest {
    id: number;
}

export interface AttachmentsV1PostRequest {
    xAttachmentType: AttachmentsV1PostXAttachmentTypeEnum;
    xAttachmentExtension: AttachmentsV1PostXAttachmentExtensionEnum;
    xAttachmentId?: number;
    xAttachmentOwnerId?: number;
    xAttachmentDealId?: number;
    xAttachmentDocumentId?: number;
    body?: string;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * start convering images to pdf
     */
    async attachmentsV1ConvertPostRaw(): Promise<runtime.ApiResponse<InlineResponse200>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/attachments/v1/convert/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse200FromJSON(jsonValue));
    }

    /**
     * start convering images to pdf
     */
    async attachmentsV1ConvertPost(): Promise<InlineResponse200> {
        const response = await this.attachmentsV1ConvertPostRaw();
        return await response.value();
    }

    /**
     * Download file
     */
    async attachmentsV1IdGetRaw(requestParameters: AttachmentsV1IdGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling attachmentsV1IdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/attachments/v1/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download file
     */
    async attachmentsV1IdGet(requestParameters: AttachmentsV1IdGetRequest): Promise<Blob> {
        const response = await this.attachmentsV1IdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Upload file
     */
    async attachmentsV1PostRaw(requestParameters: AttachmentsV1PostRequest): Promise<runtime.ApiResponse<InlineResponse200>> {
        if (requestParameters.xAttachmentType === null || requestParameters.xAttachmentType === undefined) {
            throw new runtime.RequiredError('xAttachmentType','Required parameter requestParameters.xAttachmentType was null or undefined when calling attachmentsV1Post.');
        }

        if (requestParameters.xAttachmentExtension === null || requestParameters.xAttachmentExtension === undefined) {
            throw new runtime.RequiredError('xAttachmentExtension','Required parameter requestParameters.xAttachmentExtension was null or undefined when calling attachmentsV1Post.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (requestParameters.xAttachmentType !== undefined && requestParameters.xAttachmentType !== null) {
            headerParameters['x-attachment-type'] = String(requestParameters.xAttachmentType);
        }

        if (requestParameters.xAttachmentId !== undefined && requestParameters.xAttachmentId !== null) {
            headerParameters['x-attachment-id'] = String(requestParameters.xAttachmentId);
        }

        if (requestParameters.xAttachmentExtension !== undefined && requestParameters.xAttachmentExtension !== null) {
            headerParameters['x-attachment-extension'] = String(requestParameters.xAttachmentExtension);
        }

        if (requestParameters.xAttachmentOwnerId !== undefined && requestParameters.xAttachmentOwnerId !== null) {
            headerParameters['x-attachment-owner-id'] = String(requestParameters.xAttachmentOwnerId);
        }

        if (requestParameters.xAttachmentDealId !== undefined && requestParameters.xAttachmentDealId !== null) {
            headerParameters['x-attachment-deal-id'] = String(requestParameters.xAttachmentDealId);
        }

        if (requestParameters.xAttachmentDocumentId !== undefined && requestParameters.xAttachmentDocumentId !== null) {
            headerParameters['x-attachment-document-id'] = String(requestParameters.xAttachmentDocumentId);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        // @TODO: no suck API point???
        const response = await this.request({
            path: `/attachments/v1/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse200FromJSON(jsonValue));
    }

    /**
     * Upload file
     */
    async attachmentsV1Post(requestParameters: AttachmentsV1PostRequest): Promise<InlineResponse200> {
        const response = await this.attachmentsV1PostRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum AttachmentsV1PostXAttachmentTypeEnum {
    Unknown = 'unknown',
    PassportFront = 'passport_front',
    PassportReverse = 'passport_reverse',
    Inn = 'inn',
    Snils = 'snils',
    Converted = 'converted',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    PassportTranslation = 'passport_translation',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MaternalCapitalCertificateBalance = 'maternal_capital_certificate_balance',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}
/**
    * @export
    * @enum {string}
    */
export enum AttachmentsV1PostXAttachmentExtensionEnum {
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    Pdf = 'pdf',
    Png = 'png'
}
